import request from '@/utils/request'

// 查询物流信息
export function getLocusList(orderNo) {
  return request({
    url: '/trade/order/h5/express/' + orderNo,
    method: 'get',
  })
}

// 获取所有物流公司列表
export function getLogisticsList() {
  return request({
    url: '/setting/logistics/list',
    method: 'get',
  })
}
// 填写物流信息
export function addLogistics(data) {
  return request({
    url: '/trade/return-delivery/addDelivery',
    method: 'post',
    data,
  })
}
// 取消订单
export function cancelInSale(data) {
  return request({
    url: '/trade/order/h5/cancel',
    method: 'post',
    data,
  })
}
// 获取订单列表
export function InSaleList(params) {
  return request({
    url: '/trade/order/h5/page',
    method: 'get',
    params,
  })
}
// 查询订单详情
export function getInSaleDetail(orderNo) {
  return request({
    url: '/trade/order/h5/detail/' + orderNo,
    method: 'get',
  })
}
